<script>
export default {
  data() {
    return {
      fab: false,
    }
  },
  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 500
    },
    toTop() {
      this.$vuetify.goTo(0)
    },
  },
}
</script>

<template>
  <v-fade-transition mode="out-in">
    <v-btn
      v-show="fab"
      v-scroll="onScroll"
      class="mr-7"
      :class="$style.scrollToTopBtn"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </v-fade-transition>
</template>

<style lang="scss" module>
@import '@design';

.scrollToTopBtn {
  margin-bottom: 100px;
}
</style>
